import { z } from 'zod';

export const PermitsStepsDocumentsScalarFieldEnumSchema = z.enum(['id','permits_step_id','documents_type_id','documents_template_id']);

export default PermitsStepsDocumentsScalarFieldEnumSchema;
